import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../atoms/spacers"
import { MediaQuery } from "../../utils/design-helpers"
import Card from "../atoms/Card"
import Subtitle from "../atoms/typography/Subtitle"
import PrimaryButton from "../atoms/buttons/PrimaryButton"
import SecondaryButton from "../atoms/buttons/SecondaryButton"
import { SettingsIcon } from "../atoms/icons/SettingsIcon"
import EditTerminalSectionDropdown from "./EditTerminalSectionDropdown"
import { TerminalDataModel } from "../../utils/models"

interface Props {
  terminals: Array<TerminalDataModel>
  cardsOpen: Array<string>
  onClickHandleOpenCard: (id: any) => void
}

const PaddedRow = styled(Row)`
  padding-inline: ${(props) => props.theme.spacings.large};
  padding-block: ${(props) => props.theme.spacings.extreme};
`

const ManageButtonSection = styled.div`
  ${MediaQuery.XS} {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 2rem;
  }
`

const OrganizationTerminalsCard: React.FC<Props> = ({ terminals, cardsOpen, onClickHandleOpenCard }) => {
  const [editMode, setEditMode] = React.useState(false)
  const onClickManage = () => setEditMode(!editMode)
  const checkIsOpen = (id: any) => {
    return cardsOpen.includes(id)
  }

  return (
    <div>
      <Card>
        <Container>
          <Col>
            <PaddedRow justify="between" align="center">
              <Subtitle>Terminals</Subtitle>
              <ManageButtonSection>
                {!editMode && (
                  <PrimaryButton title="Manage terminals" icon={<SettingsIcon />} onClick={onClickManage} />
                )}
                {editMode && <SecondaryButton title="Done" onClick={onClickManage} />}
              </ManageButtonSection>
            </PaddedRow>
          </Col>
        </Container>
        {terminals.map((terminal: TerminalDataModel) => (
          <div key={terminal.id}>
            <EditTerminalSectionDropdown
              terminalDataPlan={terminal.dataplan}
              terminalId={terminal.id}
              terminalImgSrc={terminal.imgSrc}
              terminalName={terminal.name}
              terminalSerialNumber={terminal.serialNumber}
              terminalSuborg={terminal.suborganization}
              sudopassword={terminal.sudoPassword}
              canEdit={editMode}
              open={checkIsOpen(terminal.id)}
              handleOpen={() => onClickHandleOpenCard(terminal.id)}
              groups={terminal.groups}
            />
            <HorizontalSpacer spacing={1} />
          </div>
        ))}
      </Card>
    </div>
  )
}

export default OrganizationTerminalsCard
